module.exports = __webpack_public_path__ + "media/stylesheets/images/boxil/BOXIL SaaS AWARD Summer 2024_サポートの品質No.1-f1ff13d2828a060b19489b4b9e1c9ab5.png";